// auth
export const SET_USER = 'SET_USER'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_BUSINESSES_LIST = 'SET_BUSINESSES_LIST'
export const SET_ACTIVE_BUSINESS = 'SET_ACTIVE_BUSINESS'
export const SET_ACTIVE_BUSINESS_BRANDING = 'SET_ACTIVE_BUSINESS_BRANDING'
export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE'
export const SET_BASIC_USER_INFO = 'SET_BASIC_USER_INFO'

// permissions
export const SET_APP_DETAILS = 'SET_APP_DETAILS'

// locations
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION'
export const SET_LOCATION_IMAGES = 'SET_LOCATION_IMAGES'
export const SET_ZONES_RELOAD = 'SET_ZONES_RELOAD'
// location Dialogs
export const SET_CREATE_LOCATION_DIALOG = 'SET_CREATE_LOCATION_DIALOG'
export const SET_LOCATION_EDIT_DIALOG = 'SET_LOCATION_EDIT_DIALOG'

// location groups
export const SET_SELECTED_LOCATION_GROUP = 'SET_SELECTED_LOCATION_GROUP'
// location groups Dialogs
export const SET_CREATE_LOCATION_GROUP_DIALOG = 'SET_CREATE_LOCATION_GROUP_DIALOG'
export const SET_LOCATION_GROUP_EDIT_DIALOG = 'SET_LOCATION_GROUP_EDIT_DIALOG'
